module.exports = __webpack_public_path__ + "public/img/ptz-icon3.fe159e65.svg";